$.plugins.dialog = {
	__init: function () {
		this.addClass('dialog');
		
		this.container = $.div().addClass('container').appendTo(this);
		
		this.pages = {};
		
		this._current = $.div();
		this._content = null;
		this._page = null;
		
		this.pager = $.div().addClass('pager').appendTo(this.container);
		
		this.pager.left = $.div().addClass('arrow left').appendTo(this.pager);
		this.pager.bubbles = $.div().addClass('bubbles').appendTo(this.pager);
		this.pager.right = $.div().addClass('arrow right').appendTo(this.pager);
		
		var dialog = this;
		
		this.pager.left.on('click', function () {
			dialog.page(dialog._page - 1);
		});
		
		this.pager.right.on('click', function () {
			dialog.page(dialog._page + 1);
		});
		
		this.pager.exit = $.div().addClass('close').appendTo(this.container);
		this.pager.exit.on('click', function () {
			dialog.hide();
		});
		
		this.addClass('show').hide();
	},
	
	hide: function () {
		this.trigger('hide', this._content);
		
		if (!this.hasClass('show')) {
			return this;
		}
		
		this.removeClass('show');
		this.reinsert();
		
		setTimeout((function () {
			if (!this.hasClass('show')) {
				this.css('display', 'none');
			}
		}).bind(this), 500);
		
		delete this._content;
		
		return this;
	},
	
	show: function (content, page) {
		if (typeof content === 'string') {
			var slug = content;
			
			content = this.pages[slug];
			
			if (!content) {
				this.trigger('unknown', slug);
				return;
			}
			
			content.slug = slug;
		}
		
		if (!content) {
			throw new Error('Unknown content: ' + content);
		}
		
		this._content = content;
		
		this.container.attr('class', 'container');
		
		if (this._content.slug) {
			this.container.addClass(this._content.slug);
		}
		
		if (this._content.constructor === Array) {
			this.pager.css('display', null);
			
			var dialog = this;
			
			this.pager.bubbles.empty();
			this.pager.bubbles.length = this._content.length;
			
			for (var i = 0; i < this.pager.bubbles.length; i++) {
				this.pager.bubbles[i] = $.div().addClass('bubble').appendTo(this.pager.bubbles);
				this.pager.bubbles[i].on('click', function () {
					dialog.page(this.index());
				});
			}
		}
		
		else {
			this.pager.css('display', 'none');
		}
		
		if (this._content.constructor === this.constructor && this._content.hasClass('noexit')) {
			this.pager.exit.css('display', 'none');
		}
		
		else {
			this.pager.exit.css('display', null);
		}
		
		this.page(page || 0);
		
		this.addClass('show');
		this.css('display', null);
		this.reinsert();
		
		this.trigger('show', this._content);
		
		return this;
	},
	
	page: function (page) {
		if (this._content.constructor === Array && !this._content[page]) {
			return;
		}
		
		if (this._content.constructor === Array) {
			this._page = page;
			
			this._current.remove();
			this._current = this._content[this._page];
			this._current.prependTo(this.container);
			
			for (var i = 0; i < this.pager.bubbles.length; i++) {
				this.pager.bubbles[i].toggleClass('active', (i === this._page));
			}
			
			if (this._page > 0) {
				this.pager.left.removeClass('disabled');
			}
			
			else {
				this.pager.left.addClass('disabled');
			}
			
			if (this._page < this._content.length - 1) {
				this.pager.right.removeClass('disabled');
			}
			
			else {
				this.pager.right.addClass('disabled');
			}
		}
		
		else {
			this._current.remove();
			this._current = this._content;
			this._current.prependTo(this.container);
		}
		
		return this;
	},
};



/** WEBPACK FOOTER **
 ** ./../../../../engine/public-src/spingames/panel/js/dialog.js
 **/